(ns teamoesterreich.admin-mode.crowdtasker.task-result.task-response-list
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.eventQuestion :as d-eventQuestion]
            [teamoesterreich.util.log :as log]

            ))


(defn get-max-index [questions]
  (reduce (fn [c e] (max c (js/parseInt (:crowdtaskerQuestion-index (second e))))) 0 questions))

(defn get-question-by-index [questions index]
  (second (first (filter #(= index (js/parseInt (:crowdtaskerQuestion-index (second %)))) questions))))

(defn get-question-by-uuid [questions uuid]
  (second (first (filter #(= uuid (:crowdtaskerQuestion-uuid (second %))) questions))))

(defn >swap-index-upwards [uuid index questions reload-fn]
  (let [index-before (reduce (fn [ic [_ {i2 :crowdtaskerQuestion-index}]]
                               (let [i2 (js/parseInt i2)] (if (and (< i2 index) (> i2 ic)) i2 ic)))
                             1 questions)]
    (when-let [uuid (:crowdtaskerQuestion-uuid (get-question-by-index questions index-before))]
      (d-eventQuestion/>question-save-index uuid (inc index-before) (fn [])))
    (d-eventQuestion/>question-save-index uuid index-before reload-fn)))

(defn >swap-index-downwards [uuid index questions reload-fn]
  (when-let [uuid (:crowdtaskerQuestion-uuid (get-question-by-index questions (inc index)))]
    (d-eventQuestion/>question-save-index uuid index (fn [])))
  (d-eventQuestion/>question-save-index uuid (inc index) reload-fn))



(defn question-card [question]

  (let []
    [mui/card {:style {:margin "3px"}}

     [mui/card {:style {:display       "flex"
                        :flexDirection "row"}}

      [mui/card-content {:style {:flex "1 0 400px"}}
       [:div  (str (:crowdtaskerQuestion-question question) " "
                                            ;(doall (for [answerOption (sort-by :crowdtaskerAnswerOption-index (filter (fn [e] (and (:crowdtaskerAnswerOption-active e) (not= (:crowdtaskerAnswerOption-type e) "radioOption")))
                                            ;                                                                          (clojure.walk/keywordize-keys (:crowdtaskerQuestion-answerOption question))))]
                                            ;         ^{:key (str "answerOption-" (:crowdtaskerAnswerOption-uuid answerOption))}
                                            ;         ;(r/as-element (case (:crowdtaskerAnswerOption-type answerOption)
                                            ;         ;                "image" [mui/chip {:label (:crowdtaskerAnswerOption-motiv answerOption) :icon (r/as-element [insert-photo]) :style {:margin "3px 3px 3px 3px"}}]
                                            ;         ;                "radio" [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption) :icon (r/as-element [radio-button-checked-two-tone]) :style {:margin "3px 3px 3px 3px"}}]
                                            ;         ;                "checkbox" [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption) :icon (r/as-element [check-box-outline-blank-two-tone]) :style {:margin "3px 3px 3px 3px"}}]
                                            ;         ;                "decimal" [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption) :icon (r/as-element [confirmation-number]) :style {:margin "3px 3px 3px 3px"}}]
                                            ;         ;                "numeric" [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption) :icon (r/as-element [confirmation-number]) :style {:margin "3px 3px 3px 3px"}}]
                                            ;         ;                "text" [mui/chip {:label (:crowdtaskerAnswerOption-hint answerOption) :icon (r/as-element [text-fields]) :style {:margin "3px 3px 3px 3px"}}]
                                            ;         ;                [mui/chip {:label (:crowdtaskerAnswerOption-text answerOption)
                                            ;         ;                           :style {:margin "3px 3px 3px 3px"}}]
                                            ;         ;                ))
                                            ;         ))
                   )
        ; FIXME: download button
        [:a {:target "_blank" :href (str backend/BASE_URL "/crowdtasker-answer/questionAnswersCsv/" (:crowdtaskerQuestion-uuid question))} "Auswertung CSV Download"]]

       ]]]
    ))


(defn get-it []
  (let [!questions (r/cursor vstate/app-state [:edit-crowdtaskerQuestion :questions])
        !loaded (r/cursor vstate/app-state [:edit-crowdtaskerQuestion :questions-loaded])
        reload-fn #(d-eventQuestion/load-task-question-list)
        ]
    (fn []

      ;(log/debug "question tab get-it task: " (clj->js @!event-task))

      (if-not @!loaded
        (do
          (d-eventQuestion/load-task-question-list #(reset! !loaded true))
          [mui/card-content {}
           [:br]
           [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
           [mui/typography {} "Lade Daten ... "]
           ]
          )
        (do


          [:div
           (log/debug "questions " @!questions)
           [mui/card-content {}
            [mui/grid
             {:container  true
              :direction  "row"
              :alignItems "stretch"
              :justify    "flex-start"

              }

             (doall (for [[uuid question] (sort-by (fn [[uuid n]] (js/parseInt (:crowdtaskerQuestion-index n)))
                                                   (filter (fn [[_ e]] (:crowdtaskerQuestion-active e)) @!questions))]
                      ^{:key (str "question-" uuid)}
                      [mui/grid
                       {:container false
                        :item      true
                        :xs        12                       ;extra-small: 0px
                        :style     {:textAlign "left" :backgroundColor "#e6e6e6"}
                        }
                       [question-card question]
                       ]
                      ))
             ]
            ]
           ]

          )
        ))))